import { Controller } from 'stimulus';
import serializeFormToObject from '@/helpers/serializeFormToObject';
import {
  getDefaultForInput,
  getLabelTextForInput,
  getInputForKeyAndValue,
  renderSelectedFilterButton,
  renderResetFilterButton,
  removeFilterForButton,
} from '@/helpers/filters';

class FiltersController extends Controller {
  connect() {
    this.outputSelectedFilters(this.getSelectedFilters());
  }

  // eslint-disable-next-line class-methods-use-this
  onFilterChange() {}

  onFilterRemove({ currentTarget }) {
    removeFilterForButton(currentTarget);

    this.outputSelectedFilters(this.getSelectedFilters());
  }

  onFilterReset() {
    this.resetFilters();
  }

  onFormSubmit() {
    this.outputSelectedFilters(this.getSelectedFilters());
  }

  getSelectedFilters() {
    const selectedValues = serializeFormToObject(this.formTarget);
    const selectedItems = [];

    if (typeof selectedValues.forEach !== 'function') {
      return selectedItems;
    }

    selectedValues.forEach((val, key) => {
      if (!val) {
        return;
      }

      const label = getLabelTextForInput(key, val);
      const input = getInputForKeyAndValue(key, val);
      const defaultValue = getDefaultForInput(input);

      if (input.value === defaultValue || !label) {
        return;
      }

      selectedItems.push({
        key,
        value: val,
        label,
      });
    });

    return selectedItems;
  }

  outputSelectedFilters(filters) {
    if (!this.hasSelectedFiltersTarget) return;

    let selectedFiltersHtml = filters.map(renderSelectedFilterButton).join('');

    if (selectedFiltersHtml !== '') {
      selectedFiltersHtml += renderResetFilterButton;
    }

    this.selectedFiltersOutputTarget.innerHTML = selectedFiltersHtml;

    this.selectedFiltersTarget.style.display = filters.length > 0 ? 'block' : 'none';
  }

  resetFilters() {
    this.filterTargets.forEach((filter) => {
      if (filter.type === 'checkbox') {
        filter.checked = false;
      } else {
        filter.value = '';
      }
    });

    this.formTarget.submit();
  }
}

FiltersController.targets = [
  'form',
  'filter',
  'selectedFilters',
  'selectedFiltersOutput',
];

export default FiltersController;
